document.addEventListener('DOMContentLoaded', () => {
  // Create a single overlay and add it to the body, if it doesn't already exist
  let overlay = document.querySelector('.popup-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.classList.add('popup-overlay');
    document.body.appendChild(overlay);
  }

  // Function to open the popup
  function openPopup(popup) {
    // Show the popup and overlay
    popup.classList.add('active');
    overlay.classList.add('active');

    // Remove any previous click event listeners on the overlay
    overlay.onclick = () => closePopup(popup);

    // Set close button functionality
    const closeButton = popup.querySelector('.close-btn');
    if (closeButton) {
      closeButton.onclick = () => closePopup(popup);
    }
  }

  // Function to close the popup
  function closePopup(popup) {
    popup.classList.remove('active');
    overlay.classList.remove('active');
  }

  // Attach click event listeners to all popup links
  document.querySelectorAll('.product-step-popup-link').forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const targetId = link.getAttribute('data-target');
      const popup = document.getElementById(targetId);

      if (popup) {
        openPopup(popup);
      }
    });
  });
});